import React from "react";
import "../../../styles/index.scss";
import FormExampleSimple from "./FormExampleSimple";
import FormExampleUser from "./FormExampleUser";

function FormExample() {
  return (
    <>
      <FormExampleSimple />
      <FormExampleUser />
    </>
  );
}

export default FormExample;
